<template>
  <router-view />
</template>

<script>
export default {
  name: 'AuthenticatedContainer',
}
</script>

<style></style>
